/* eslint-disable no-console */
import { log, supabase } from ".";

export const getOportunidadesBTL = async ({ pais, ano, orderBy = "created_at", ascending = true }) => {
  try {
    const data = await supabase.select("sales_btl", {
      filters: {
        ano: parseInt(ano),
      },
      orderBy,
      ascending,
    });

    return data || []; // Return data if it exists, otherwise an empty array
  } catch (error) {
    log.error("getOportunidadesBTL", error);
    throw error;
  }
};
